module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-105.fd308fc.woff2";